import CampaignIcon from '@mui/icons-material/Campaign';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FlagIcon from '@mui/icons-material/Flag';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ViewListIcon from '@mui/icons-material/ViewList';
import Badge from '@mui/material/Badge';
import { useState } from 'react';
import { Menu } from 'react-admin';
import { usePendingCounts } from '../hooks/usePendingCounts';
import SubMenu from './SubMenu';

export const MyMenu = (props: any) => {
  const [state, setState] = useState({
    menuAds: true,
  });
  const pending = usePendingCounts();

  const handleToggle = (menu: string) => {
    setState((state) => ({ ...state, [menu]: !state[menu as keyof typeof state] }));
  };

  return (
    <Menu {...props}>
      <Menu.Item to="/" primaryText="Dashboard" leftIcon={<DashboardIcon />} />

      <SubMenu
        handleToggle={() => handleToggle('menuAds')}
        isOpen={state.menuAds}
        name="Advertising"
        icon={<CampaignIcon />}
      >
        <Menu.Item
          to="/advertiser-accounts"
          primaryText="Advertisers"
          leftIcon={<StorefrontIcon />}
        />
        <Menu.Item to="/campaigns" primaryText="Campaigns" leftIcon={<CampaignIcon />} />
        <Menu.Item to="/ads" primaryText="Ads" leftIcon={<ViewListIcon />} />
      </SubMenu>

      <Menu.Item
        to="/questionReports"
        primaryText="Question Reports"
        leftIcon={
          <Badge badgeContent={pending.questionReports} color="error">
            <ReportProblemIcon />
          </Badge>
        }
      />
      <Menu.Item
        to="/comment-reports"
        primaryText="Reported Comments"
        leftIcon={
          <Badge badgeContent={pending.commentReports} color="error">
            <FlagIcon />
          </Badge>
        }
      />
      <Menu.Item to="/image-runs" primaryText="Image Runs" leftIcon={<PhotoLibraryIcon />} />
    </Menu>
  );
};
